import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadIssueIndentList = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadIssuedIndentNumber = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.ISSUED_INDENT_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadIssueDetail = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.ISSUED_GET_REQUEST_INDENT_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const IssuedIndentCRUD = async (api, payload) => {
    try {       
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};